import { URL } from 'src/constants/links';

import { ADMIN_APP_ASSET_PATHS } from 'src/constants/assets';
import { getAssetURL } from 'src/helpers';

export const AI_POWERED_SEARCH_NAME = 'AI-powered-search';
export const AI_POWERED_RECOMMENDATION_NAME = 'AI-powered-recommendation';
export const VISUAL_MERCHANDISING_NAME = 'visual-merchandising';
export const VARIANT_DISPLAY_NAME = 'variant-display';
export const SYNC_FREQUENCY_NAME = 'sync-frequency';
export const ANALYTICS_ADDON_NAME = 'analytics';
export const LARGE_PRODUCT = 50000;
export const LARGE_PRODUCT_LABEL = '50,000+';
export const MAX_PRODUCTS_FREEMIUM = 25;
export const REQUEST_LARGE_PLAN = 'request_large_plan';

export const TYPE_PACKAGES_V4 = {
  Freemium: 'freemium',
  Basic: 'basic',
  Essential: 'essential',
  Professional: 'professional'
};

export const PRICING_V4_START_WITH_PRODUCTS = {
  basic: 500,
  essential: 5000,
  professional: 5000
};

export const PACKAGES = [
  {
    name: 'basic',
    title: 'AdminHTML.SubscriptionV3.Packages.package01',
    advanceLabel: 'AdminHTML.SubscriptionV3.Packages.advanceTitleCard01',
    addons: ['30-analytics'],
    subtext: 'AdminHTML.SubscriptionV3.Packages.BasicPackage.subtext',
    basicList: [
      'AdminHTML.SubscriptionV3.Packages.BasicPackage.contentO1',
      'AdminHTML.SubscriptionV3.Packages.BasicPackage.contentO2',
      'AdminHTML.SubscriptionV3.Packages.BasicPackage.contentO3',
      'AdminHTML.SubscriptionV3.Packages.BasicPackage.contentO4',
      'AdminHTML.SubscriptionV3.Packages.BasicPackage.contentO8',
      'AdminHTML.SubscriptionV3.Addons.Analytics.analytics01',
      // 'AdminHTML.SubscriptionV3.Packages.BasicPackage.contentO5',
      'AdminHTML.SubscriptionV3.Packages.BasicPackage.contentO6'
    ],
    advanceList: [
      'AdminHTML.SubscriptionV3.Packages.BasicPackage.contentO2',
      'AdminHTML.SubscriptionV3.Packages.BasicPackage.contentO3',
      'AdminHTML.SubscriptionV3.Packages.BasicPackage.contentO9',
      'AdminHTML.SubscriptionV3.Packages.BasicPackage.contentO4',
      'AdminHTML.SubscriptionV3.Packages.BasicPackage.content11',
      'AdminHTML.SubscriptionV3.Packages.BasicPackage.contentO8',
      'AdminHTML.SubscriptionV3.Packages.BasicPackage.contentO5',
      'AdminHTML.SubscriptionV3.Packages.BasicPackage.content10',
      'AdminHTML.SubscriptionV3.Addons.Analytics.analytics01'
    ]
  },
  {
    name: 'essential',
    title: 'AdminHTML.SubscriptionV3.Packages.package02',
    subtext: 'AdminHTML.SubscriptionV3.Packages.EssentialPackage.subtext',
    advanceLabel: 'AdminHTML.SubscriptionV3.Packages.advanceTitleCard02',
    addons: ['90-analytics', 'aiPowerSearch', 'aiPowerRecommendation', 'visualMerchandising'],
    basicList: [
      'AdminHTML.SubscriptionV3.Packages.EssentialPackage.contentO1',
      'AdminHTML.SubscriptionV3.Packages.EssentialPackage.contentO2',
      'AdminHTML.SubscriptionV3.Packages.EssentialPackage.contentO3',
      'AdminHTML.SubscriptionV3.Packages.EssentialPackage.contentO4',
      // 'AdminHTML.SubscriptionV3.Packages.EssentialPackage.contentO5',
      'AdminHTML.SubscriptionV3.Packages.EssentialPackage.contentO6'
    ],
    advanceList: [
      'AdminHTML.SubscriptionV3.Addons.AddonFeature.feature01.name',
      'AdminHTML.SubscriptionV3.Addons.AddonFeature.feature02.name',
      'AdminHTML.SubscriptionV3.Packages.EssentialPackage.contentO7',
      'AdminHTML.SubscriptionV3.Addons.AddonFeature.feature03.name',
      'AdminHTML.SubscriptionV3.Packages.EssentialPackage.content08',
      'AdminHTML.SubscriptionV3.Addons.Analytics.analytics02',
      'AdminHTML.SubscriptionV3.Packages.EssentialPackage.content09',
      'AdminHTML.SubscriptionV3.Packages.EssentialPackage.content10',
    ]
  },
  {
    name: 'professional',
    title: 'AdminHTML.SubscriptionV3.Packages.package03',
    subtext: 'AdminHTML.SubscriptionV3.Packages.ProfessionalPackage.subtext',
    advanceLabel: 'AdminHTML.SubscriptionV3.Packages.advanceTitleCard03',
    addons: [
      'aiPowerSearch',
      'aiPowerRecommendation',
      'visualMerchandising',
      'variantDisplay',
      // 'syncFrequency',
      '180-analytics'
    ],
    basicList: [
      'AdminHTML.SubscriptionV3.Packages.ProfessionalPackage.contentO1',
      'AdminHTML.SubscriptionV3.Packages.ProfessionalPackage.contentO2',
      'AdminHTML.SubscriptionV3.Packages.ProfessionalPackage.contentO3',
      'AdminHTML.SubscriptionV3.Packages.ProfessionalPackage.contentO4'
    ],
    advanceList: [
      'AdminHTML.SubscriptionV3.Addons.AddonFeature.feature07.advance01',
      'AdminHTML.SubscriptionV3.Addons.AddonFeature.feature07.advance02',
      'AdminHTML.SubscriptionV3.Packages.ProfessionalPackage.contentO5',
      'AdminHTML.SubscriptionV3.Addons.AddonFeature.feature04.name',
      'AdminHTML.SubscriptionV3.Addons.Analytics.analytics03',
      'AdminHTML.SubscriptionV3.Packages.ProfessionalPackage.contentO7'
      // 'AdminHTML.SubscriptionV3.Addons.AddonFeature.feature06.label'
    ]
  }
];

export const GOOD_REVIEWS = [
  {
    name: 'Retail International Group',
    date: 'About 4 years using the app',
    content: `“Great app and excellent support. We've been using the app for quite some time now. Recently we had a small issue which was resolved in no time. Highly recommended!”`
  },
  {
    name: 'SAYN',
    date: 'Over 2 years using the app',
    content: `“The support is some of the best I have ever experienced from a platform. Any issue you have is resolved within 24 hours. The platform itself is great as well.”`
  },
  {
    name: 'Sok-It',
    date: 'About 3 years using the app',
    content: `“First, Boost has AMAZING customer service. That's key for me with any Shopify app. Second, the app works incredibly well. The filtering options are easy to set up and implement, and the AI search is unmatched. Truly a great app I'd recommend to anyone.”`
  },
  {
    name: 'Aviator Nation',
    date: 'Over 1 year using the app',
    content: `“Team us quick and responsive to our questions, needs! We've enjoyed working with them for a number of years now.”`
  },
  {
    name: 'The Tech Den',
    date: 'About 4 years using the app',
    content: `“Email customer service was fast and efficient. They resolved our issue within a day. Great customer service.”`
  },
  {
    name: 'Andrea Biani',
    date: 'Over 2 years using the app',
    content: `“Good app with a great support team. Always happy to help with whatever I need to change! They respond within 24 hours despite being on the other side of the world.”`
  }
];

export const PACKAGES_V4 = [
  {
    name: 'freemium',
    title: 'AdminHTML.SubscriptionV4.Packages.freemium.title',
    advanceLabel: 'AdminHTML.SubscriptionV3.Packages.advanceTitleCard01',
    addons: ['30-analytics'],
    subtext: 'AdminHTML.SubscriptionV3.Packages.BasicPackage.subtext',
    featuresLabel: 'AdminHTML.SubscriptionV4.Packages.freemium.label',
    features: [
      'AdminHTML.SubscriptionV4.Packages.freemium.feature_filter',
      'AdminHTML.SubscriptionV4.Packages.freemium.feature_search',
      'AdminHTML.SubscriptionV4.Packages.freemium.feature_hand',
      'AdminHTML.SubscriptionV4.Packages.freemium.feature_7days',
      'AdminHTML.SubscriptionV4.Packages.freemium.feature_visual'
    ],
    basicList: [
      'AdminHTML.SubscriptionV3.Packages.BasicPackage.contentO1',
      'AdminHTML.SubscriptionV3.Packages.BasicPackage.contentO2',
      'AdminHTML.SubscriptionV3.Packages.BasicPackage.contentO3',
      'AdminHTML.SubscriptionV3.Packages.BasicPackage.contentO4',
      'AdminHTML.SubscriptionV3.Packages.BasicPackage.contentO8',
      'AdminHTML.SubscriptionV3.Addons.Analytics.analytics01',
      // 'AdminHTML.SubscriptionV3.Packages.BasicPackage.contentO5',
      'AdminHTML.SubscriptionV3.Packages.BasicPackage.contentO6'
    ],
    advanceList: [
      'AdminHTML.SubscriptionV3.Packages.BasicPackage.contentO2',
      'AdminHTML.SubscriptionV3.Packages.BasicPackage.contentO3',
      'AdminHTML.SubscriptionV3.Packages.BasicPackage.contentO9',
      'AdminHTML.SubscriptionV3.Packages.BasicPackage.contentO4',
      'AdminHTML.SubscriptionV3.Packages.BasicPackage.contentO8',
      'AdminHTML.SubscriptionV3.Packages.BasicPackage.contentO5',
      'AdminHTML.SubscriptionV3.Packages.BasicPackage.content10',
      'AdminHTML.SubscriptionV3.Addons.Analytics.analytics01'
    ]
  },
  {
    name: 'basic',
    title: 'AdminHTML.SubscriptionV4.Packages.basic.title',
    advanceLabel: 'AdminHTML.SubscriptionV3.Packages.advanceTitleCard01',
    addons: ['90-analytics'],
    subtext: 'AdminHTML.SubscriptionV3.Packages.BasicPackage.subtext',
    featuresLabel: 'AdminHTML.SubscriptionV4.Packages.basic.label',
    features: [
      'AdminHTML.SubscriptionV4.Packages.basic.feature_advanced_filter',
      'AdminHTML.SubscriptionV4.Packages.basic.feature_search',
      'AdminHTML.SubscriptionV4.Packages.basic.feature_6rec',
      'AdminHTML.SubscriptionV4.Packages.basic.feature_predictive_bundle',
      'AdminHTML.SubscriptionV4.Packages.basic.feature_meta',
      'AdminHTML.SubscriptionV4.Packages.basic.feature_search_mer',
      'AdminHTML.SubscriptionV4.Packages.basic.feature_standard',
      'AdminHTML.SubscriptionV4.Packages.basic.feature_30theme',
      'AdminHTML.SubscriptionV4.Packages.basic.feature_30days',
      'AdminHTML.SubscriptionV4.Packages.basic.feature_shopify_market'
    ],
    basicList: [
      'AdminHTML.SubscriptionV3.Packages.BasicPackage.contentO1',
      'AdminHTML.SubscriptionV3.Packages.BasicPackage.contentO2',
      'AdminHTML.SubscriptionV3.Packages.BasicPackage.contentO3',
      'AdminHTML.SubscriptionV3.Packages.BasicPackage.contentO4',
      'AdminHTML.SubscriptionV3.Packages.BasicPackage.content11',
      'AdminHTML.SubscriptionV3.Packages.BasicPackage.contentO8',
      'AdminHTML.SubscriptionV3.Addons.Analytics.analytics01',
      // 'AdminHTML.SubscriptionV3.Packages.BasicPackage.contentO5',
      'AdminHTML.SubscriptionV3.Packages.BasicPackage.contentO6'
    ],
    advanceList: [
      'AdminHTML.SubscriptionV3.Packages.BasicPackage.contentO2',
      'AdminHTML.SubscriptionV3.Packages.BasicPackage.contentO3',
      'AdminHTML.SubscriptionV3.Packages.BasicPackage.contentO9',
      'AdminHTML.SubscriptionV3.Packages.BasicPackage.contentO4',
      'AdminHTML.SubscriptionV3.Packages.BasicPackage.content11',
      'AdminHTML.SubscriptionV3.Packages.BasicPackage.contentO8',
      'AdminHTML.SubscriptionV3.Packages.BasicPackage.contentO5',
      'AdminHTML.SubscriptionV3.Packages.BasicPackage.content10',
      'AdminHTML.SubscriptionV3.Addons.Analytics.analytics01'
    ]
  },
  {
    name: 'essential',
    title: 'AdminHTML.SubscriptionV4.Packages.essential.title',
    subtext: 'AdminHTML.SubscriptionV3.Packages.EssentialPackage.subtext',
    advanceLabel: 'AdminHTML.SubscriptionV3.Packages.advanceTitleCard02',
    addons: ['180-analytics', 'aiPowerSearch', 'aiPowerRecommendation'],
    featuresLabel: 'AdminHTML.SubscriptionV4.Packages.essential.label',
    features: [
      'AdminHTML.SubscriptionV4.Packages.essential.feature_ai_search',
      'AdminHTML.SubscriptionV4.Packages.essential.feature_ai_rec',
      'AdminHTML.SubscriptionV4.Packages.essential.feature_ai_bundle',
      'AdminHTML.SubscriptionV4.Packages.essential.feature_ai_inCollectionSearch',
      'AdminHTML.SubscriptionV4.Packages.essential.feature_PreOrder',
      'AdminHTML.SubscriptionV4.Packages.essential.feature_90days',
      'AdminHTML.SubscriptionV4.Packages.essential.feature_B2B',
      'AdminHTML.SubscriptionV4.Packages.essential.feature_BackInStockNotification',
      'AdminHTML.SubscriptionV4.Packages.essential.feature_post_purchase',
    ],
    basicList: [
      'AdminHTML.SubscriptionV3.Packages.EssentialPackage.contentO1',
      'AdminHTML.SubscriptionV3.Packages.EssentialPackage.contentO2',
      'AdminHTML.SubscriptionV3.Packages.EssentialPackage.contentO3',
      'AdminHTML.SubscriptionV3.Packages.EssentialPackage.contentO4',
      'AdminHTML.SubscriptionV3.Packages.EssentialPackage.contentO7',
      // 'AdminHTML.SubscriptionV3.Packages.EssentialPackage.contentO5',
      'AdminHTML.SubscriptionV3.Packages.EssentialPackage.contentO6'
    ],
    advanceList: [
      'AdminHTML.SubscriptionV3.Addons.AddonFeature.feature01.name',
      'AdminHTML.SubscriptionV3.Addons.AddonFeature.feature02.name',
      'AdminHTML.SubscriptionV3.Addons.Analytics.analytics03'
    ]
  },
  {
    name: 'professional',
    title: 'AdminHTML.SubscriptionV4.Packages.professional.title',
    subtext: 'AdminHTML.SubscriptionV3.Packages.ProfessionalPackage.subtext',
    advanceLabel: 'AdminHTML.SubscriptionV3.Packages.advanceTitleCard03',
    addons: [
      'aiPowerSearch',
      'aiPowerRecommendation',
      'visualMerchandising',
      'variantDisplay',
      // 'syncFrequency',
      '180-analytics'
    ],
    featuresLabel: 'AdminHTML.SubscriptionV4.Packages.professional.label',
    features: [
      'AdminHTML.SubscriptionV4.Packages.professional.feature_ai_search',
      'AdminHTML.SubscriptionV4.Packages.professional.feature_ai_rec',
      'AdminHTML.SubscriptionV4.Packages.professional.feature_ai_bundle',
      'AdminHTML.SubscriptionV4.Packages.professional.feature_collection',
      // 'AdminHTML.SubscriptionV4.Packages.professional.feature_promotion',
      'AdminHTML.SubscriptionV4.Packages.professional.feature_variant',
      'AdminHTML.SubscriptionV4.Packages.professional.feature_180days',
      'AdminHTML.SubscriptionV4.Packages.professional.feature_customer',
      'AdminHTML.SubscriptionV4.Packages.professional.feature_premium',
      'AdminHTML.SubscriptionV4.Packages.professional.feature_custom',
      'AdminHTML.SubscriptionV4.Packages.professional.feature_BackInStockNotification'
    ],
    basicList: [
      'AdminHTML.SubscriptionV3.Packages.ProfessionalPackage.contentO1',
      'AdminHTML.SubscriptionV3.Packages.ProfessionalPackage.contentO2',
      'AdminHTML.SubscriptionV3.Packages.ProfessionalPackage.contentO3',
      'AdminHTML.SubscriptionV3.Packages.ProfessionalPackage.contentO4',
      'AdminHTML.SubscriptionV3.Packages.ProfessionalPackage.contentO5'
    ],
    advanceList: [
      'AdminHTML.SubscriptionV3.Addons.AddonFeature.feature02.name',
      'AdminHTML.SubscriptionV3.Addons.AddonFeature.feature03.name',
      'AdminHTML.SubscriptionV3.Addons.AddonFeature.feature04.name',
      'AdminHTML.SubscriptionV3.Addons.Analytics.analytics04'
      // 'AdminHTML.SubscriptionV3.Addons.AddonFeature.feature06.label'
    ]
  }
];

export const SUBSCRIPTION_V4_DOWNGRADE_COMPARE = {
  ESS_2_BASIC: {
    LEFT: {
      plan: 'AdminHTML.SubscriptionV4.Banner.DowngradeCompare.plan_essential',
      features: [
        {
          name: 'AdminHTML.SubscriptionV4.Banner.DowngradeCompare.Feature.Search',
          items: [
            [true, 'AdminHTML.SubscriptionV4.Banner.DowngradeCompare.Feature.Search_sematic', true],
            [true, 'AdminHTML.SubscriptionV4.Banner.DowngradeCompare.Feature.Search_synonym', true],
            [true, 'AdminHTML.SubscriptionV4.Banner.DowngradeCompare.Feature.Search_ppr']
          ]
        },
        {
          name: 'AdminHTML.SubscriptionV4.Banner.DowngradeCompare.Feature.Recommendation',
          items: [
            [true, 'AdminHTML.SubscriptionV4.Banner.DowngradeCompare.Feature.Recommendation_fre'],
            [true, 'AdminHTML.SubscriptionV4.Banner.DowngradeCompare.Feature.Recommendation_rel'],
            [
              true,
              'AdminHTML.SubscriptionV4.Banner.DowngradeCompare.Feature.Recommendation_freBundle'
            ]
          ]
        },
        {
          name: 'AdminHTML.SubscriptionV4.Banner.DowngradeCompare.Feature.Merchandising',
          items: [
            [true, 'AdminHTML.SubscriptionV4.Banner.DowngradeCompare.Feature.Merchandising_search'],
            [true, 'AdminHTML.SubscriptionV4.Banner.DowngradeCompare.Feature.Merchandising_40']
          ]
        },
        {
          name: 'AdminHTML.SubscriptionV4.Banner.DowngradeCompare.Feature.Product',
          items: [[true, 'AdminHTML.SubscriptionV4.Banner.DowngradeCompare.Feature.Product_20']]
        },
        {
          name: 'AdminHTML.SubscriptionV4.Banner.DowngradeCompare.Feature.Analytics',
          items: [[true, 'AdminHTML.SubscriptionV4.Banner.DowngradeCompare.Feature.Analytics_180']]
        }
      ]
    },
    RIGHT: {
      plan: 'AdminHTML.SubscriptionV4.Banner.DowngradeCompare.plan_basic',
      features: [
        {
          name: 'AdminHTML.SubscriptionV4.Banner.DowngradeCompare.Feature.Search',
          items: [
            [
              false,
              'AdminHTML.SubscriptionV4.Banner.DowngradeCompare.Feature.Search_sematic',
              true
            ],
            [
              false,
              'AdminHTML.SubscriptionV4.Banner.DowngradeCompare.Feature.Search_synonym',
              true
            ],
            [false, 'AdminHTML.SubscriptionV4.Banner.DowngradeCompare.Feature.Search_ppr']
          ]
        },
        {
          name: 'AdminHTML.SubscriptionV4.Banner.DowngradeCompare.Feature.Recommendation',
          items: [
            [false, 'AdminHTML.SubscriptionV4.Banner.DowngradeCompare.Feature.Recommendation_fre'],
            [false, 'AdminHTML.SubscriptionV4.Banner.DowngradeCompare.Feature.Recommendation_rel'],
            [
              false,
              'AdminHTML.SubscriptionV4.Banner.DowngradeCompare.Feature.Recommendation_freBundle'
            ]
          ]
        },
        {
          name: 'AdminHTML.SubscriptionV4.Banner.DowngradeCompare.Feature.Merchandising',
          items: [
            [true, 'AdminHTML.SubscriptionV4.Banner.DowngradeCompare.Feature.Merchandising_search'],
            [true, 'AdminHTML.SubscriptionV4.Banner.DowngradeCompare.Feature.Merchandising_10']
          ]
        },
        {
          name: 'AdminHTML.SubscriptionV4.Banner.DowngradeCompare.Feature.Product',
          items: [[true, 'AdminHTML.SubscriptionV4.Banner.DowngradeCompare.Feature.Product_5']]
        },
        {
          name: 'AdminHTML.SubscriptionV4.Banner.DowngradeCompare.Feature.Analytics',
          items: [[true, 'AdminHTML.SubscriptionV4.Banner.DowngradeCompare.Feature.Analytics_90']]
        },
        {
          name: 'AdminHTML.SubscriptionV4.Banner.DowngradeCompare.Feature.Shopify_market',
          items: [[true, 'AdminHTML.SubscriptionV4.Banner.DowngradeCompare.Feature.Shopify_market']]
        },
        {
          name: 'AdminHTML.SubscriptionV4.Banner.DowngradeCompare.Feature.b2B',
          items: [
            [false, 'AdminHTML.SubscriptionV4.Banner.DowngradeCompare.Feature.b2B_Sync'],
            [false, 'AdminHTML.SubscriptionV4.Banner.DowngradeCompare.Feature.b2B_Editor']
          ]
        }
      ]
    }
  },
  PRO_2_ESS: {
    LEFT: {
      plan: 'AdminHTML.SubscriptionV4.Banner.DowngradeCompare.plan_professional',
      features: [
        {
          name: 'AdminHTML.SubscriptionV4.Banner.DowngradeCompare.Feature.Personalized',
          items: [
            [
              true,
              'AdminHTML.SubscriptionV4.Banner.DowngradeCompare.Feature.Personalized_search',
              true
            ],
            [
              true,
              'AdminHTML.SubscriptionV4.Banner.DowngradeCompare.Feature.Personalized_rec',
              true
            ],
            [
              true,
              'AdminHTML.SubscriptionV4.Banner.DowngradeCompare.Feature.Personalized_bundles',
              true
            ]
          ]
        },
        {
          name: 'AdminHTML.SubscriptionV4.Banner.DowngradeCompare.Feature.Recommendation',
          items: [
            [
              true,
              'AdminHTML.SubscriptionV4.Banner.DowngradeCompare.Feature.Recommendation_relBundle'
            ]
          ]
        },
        {
          name: 'AdminHTML.SubscriptionV4.Banner.DowngradeCompare.Feature.Merchandising',
          items: [
            [true, 'AdminHTML.SubscriptionV4.Banner.DowngradeCompare.Feature.Merchandising_col']
            // [true, 'AdminHTML.SubscriptionV4.Banner.DowngradeCompare.Feature.Merchandising_pro']
          ]
        },
        {
          name: 'AdminHTML.SubscriptionV4.Banner.DowngradeCompare.Feature.Variant',
          items: [
            [true, 'AdminHTML.SubscriptionV4.Banner.DowngradeCompare.Feature.Variant_display']
          ]
        },
        {
          name: 'AdminHTML.SubscriptionV4.Banner.DowngradeCompare.Feature.Product',
          items: [
            [true, 'AdminHTML.SubscriptionV4.Banner.DowngradeCompare.Feature.Product_unlimit']
          ]
        },
        {
          name: 'AdminHTML.SubscriptionV4.Banner.DowngradeCompare.Feature.Analytics',
          items: [[true, 'AdminHTML.SubscriptionV4.Banner.DowngradeCompare.Feature.Analytic3_365']]
        },
        {
          name: 'AdminHTML.SubscriptionV4.Banner.DowngradeCompare.Feature.Support',
          items: [
            [true, 'AdminHTML.SubscriptionV4.Banner.DowngradeCompare.Feature.Support_cs'],
            [true, 'AdminHTML.SubscriptionV4.Banner.DowngradeCompare.Feature.Support_psp'],
            [true, 'AdminHTML.SubscriptionV4.Banner.DowngradeCompare.Feature.Support_custom']
          ]
        }
      ]
    },
    RIGHT: {
      plan: 'AdminHTML.SubscriptionV4.Banner.DowngradeCompare.plan_essential',
      features: [
        {
          name: 'AdminHTML.SubscriptionV4.Banner.DowngradeCompare.Feature.Personalized',
          items: [
            [
              false,
              'AdminHTML.SubscriptionV4.Banner.DowngradeCompare.Feature.Personalized_search',
              true
            ],
            [
              false,
              'AdminHTML.SubscriptionV4.Banner.DowngradeCompare.Feature.Personalized_rec',
              true
            ],
            [
              false,
              'AdminHTML.SubscriptionV4.Banner.DowngradeCompare.Feature.Personalized_bundles',
              true
            ]
          ]
        },
        {
          name: 'AdminHTML.SubscriptionV4.Banner.DowngradeCompare.Feature.Recommendation',
          items: [
            [
              false,
              'AdminHTML.SubscriptionV4.Banner.DowngradeCompare.Feature.Recommendation_relBundle'
            ]
          ]
        },
        {
          name: 'AdminHTML.SubscriptionV4.Banner.DowngradeCompare.Feature.Merchandising',
          items: [
            [false, 'AdminHTML.SubscriptionV4.Banner.DowngradeCompare.Feature.Merchandising_col']
            // [false, 'AdminHTML.SubscriptionV4.Banner.DowngradeCompare.Feature.Merchandising_pro']
          ]
        },
        {
          name: 'AdminHTML.SubscriptionV4.Banner.DowngradeCompare.Feature.Variant',
          items: [
            [false, 'AdminHTML.SubscriptionV4.Banner.DowngradeCompare.Feature.Variant_display']
          ]
        },
        {
          name: 'AdminHTML.SubscriptionV4.Banner.DowngradeCompare.Feature.Product',
          items: [[true, 'AdminHTML.SubscriptionV4.Banner.DowngradeCompare.Feature.Product_20']]
        },
        {
          name: 'AdminHTML.SubscriptionV4.Banner.DowngradeCompare.Feature.Analytics',
          items: [[true, 'AdminHTML.SubscriptionV4.Banner.DowngradeCompare.Feature.Analytics_180']]
        },
        {
          name: 'AdminHTML.SubscriptionV4.Banner.DowngradeCompare.Feature.Support',
          items: [
            [false, 'AdminHTML.SubscriptionV4.Banner.DowngradeCompare.Feature.Support_cs'],
            [false, 'AdminHTML.SubscriptionV4.Banner.DowngradeCompare.Feature.Support_psp'],
            [false, 'AdminHTML.SubscriptionV4.Banner.DowngradeCompare.Feature.Support_custom']
          ]
        }
      ]
    }
  },
  PRO_2_BASIC: {
    LEFT: {
      plan: 'AdminHTML.SubscriptionV4.Banner.DowngradeCompare.plan_professional',
      features: [
        {
          name: 'AdminHTML.SubscriptionV4.Banner.DowngradeCompare.Feature.Personalized',
          items: [
            [
              true,
              'AdminHTML.SubscriptionV4.Banner.DowngradeCompare.Feature.Personalized_search',
              true
            ],
            [
              true,
              'AdminHTML.SubscriptionV4.Banner.DowngradeCompare.Feature.Personalized_rec',
              true
            ],
            [
              true,
              'AdminHTML.SubscriptionV4.Banner.DowngradeCompare.Feature.Personalized_bundles',
              true
            ]
          ]
        },
        {
          name: 'AdminHTML.SubscriptionV4.Banner.DowngradeCompare.Feature.Search',
          items: [
            [true, 'AdminHTML.SubscriptionV4.Banner.DowngradeCompare.Feature.Search_sematic'],
            [true, 'AdminHTML.SubscriptionV4.Banner.DowngradeCompare.Feature.Search_synonym'],
            [true, 'AdminHTML.SubscriptionV4.Banner.DowngradeCompare.Feature.Search_ppr']
          ]
        },
        {
          name: 'AdminHTML.SubscriptionV4.Banner.DowngradeCompare.Feature.Recommendation',
          items: [
            [true, 'AdminHTML.SubscriptionV4.Banner.DowngradeCompare.Feature.Recommendation_fre'],
            [true, 'AdminHTML.SubscriptionV4.Banner.DowngradeCompare.Feature.Recommendation_rel'],
            [
              true,
              'AdminHTML.SubscriptionV4.Banner.DowngradeCompare.Feature.Recommendation_freBundle'
            ],
            [
              true,
              'AdminHTML.SubscriptionV4.Banner.DowngradeCompare.Feature.Recommendation_relBundle'
            ]
          ]
        },
        {
          name: 'AdminHTML.SubscriptionV4.Banner.DowngradeCompare.Feature.Merchandising',
          items: [
            [true, 'AdminHTML.SubscriptionV4.Banner.DowngradeCompare.Feature.Merchandising_search'],
            [true, 'AdminHTML.SubscriptionV4.Banner.DowngradeCompare.Feature.Merchandising_100']
          ]
        },

        {
          name: 'AdminHTML.SubscriptionV4.Banner.DowngradeCompare.Feature.Product',
          items: [
            [true, 'AdminHTML.SubscriptionV4.Banner.DowngradeCompare.Feature.Product_unlimit']
          ]
        },
        {
          name: 'AdminHTML.SubscriptionV4.Banner.DowngradeCompare.Feature.Analytics',
          items: [[true, 'AdminHTML.SubscriptionV4.Banner.DowngradeCompare.Feature.Analytic3_365']]
        },

        {
          name: 'AdminHTML.SubscriptionV4.Banner.DowngradeCompare.Feature.more',
          items: []
        }
      ]
    },
    RIGHT: {
      plan: 'AdminHTML.SubscriptionV4.Banner.DowngradeCompare.plan_basic',
      features: [
        {
          name: 'AdminHTML.SubscriptionV4.Banner.DowngradeCompare.Feature.Personalized',
          items: [
            [
              false,
              'AdminHTML.SubscriptionV4.Banner.DowngradeCompare.Feature.Personalized_search',
              true
            ],
            [
              false,
              'AdminHTML.SubscriptionV4.Banner.DowngradeCompare.Feature.Personalized_rec',
              true
            ],
            [
              false,
              'AdminHTML.SubscriptionV4.Banner.DowngradeCompare.Feature.Personalized_bundles',
              true
            ]
          ]
        },
        {
          name: 'AdminHTML.SubscriptionV4.Banner.DowngradeCompare.Feature.Search',
          items: [
            [false, 'AdminHTML.SubscriptionV4.Banner.DowngradeCompare.Feature.Search_sematic'],
            [false, 'AdminHTML.SubscriptionV4.Banner.DowngradeCompare.Feature.Search_synonym'],
            [false, 'AdminHTML.SubscriptionV4.Banner.DowngradeCompare.Feature.Search_ppr']
          ]
        },
        {
          name: 'AdminHTML.SubscriptionV4.Banner.DowngradeCompare.Feature.Recommendation',
          items: [
            [false, 'AdminHTML.SubscriptionV4.Banner.DowngradeCompare.Feature.Recommendation_fre'],
            [false, 'AdminHTML.SubscriptionV4.Banner.DowngradeCompare.Feature.Recommendation_rel'],
            [
              false,
              'AdminHTML.SubscriptionV4.Banner.DowngradeCompare.Feature.Recommendation_freBundle'
            ],
            [
              false,
              'AdminHTML.SubscriptionV4.Banner.DowngradeCompare.Feature.Recommendation_relBundle'
            ]
          ]
        },
        {
          name: 'AdminHTML.SubscriptionV4.Banner.DowngradeCompare.Feature.Merchandising',
          items: [
            [true, 'AdminHTML.SubscriptionV4.Banner.DowngradeCompare.Feature.Merchandising_search'],
            [true, 'AdminHTML.SubscriptionV4.Banner.DowngradeCompare.Feature.Merchandising_10']
          ]
        },

        {
          name: 'AdminHTML.SubscriptionV4.Banner.DowngradeCompare.Feature.Product',
          items: [[true, 'AdminHTML.SubscriptionV4.Banner.DowngradeCompare.Feature.Product_5']]
        },
        {
          name: 'AdminHTML.SubscriptionV4.Banner.DowngradeCompare.Feature.Analytics',
          items: [[true, 'AdminHTML.SubscriptionV4.Banner.DowngradeCompare.Feature.Analytics_90']]
        },
        {
          name: 'AdminHTML.SubscriptionV4.Banner.DowngradeCompare.Feature.b2B',
          items: [
            [false, 'AdminHTML.SubscriptionV4.Banner.DowngradeCompare.Feature.b2B_Sync'],
            [false, 'AdminHTML.SubscriptionV4.Banner.DowngradeCompare.Feature.b2B_Editor']
          ]
        }
      ]
    }
  }
};

export const ADDONS_INFO = [
  {
    name: 'aiPowerSearch',
    addonName: 'AI-powered-search',
    image: getAssetURL(ADMIN_APP_ASSET_PATHS?.subscriptionV3?.aiPowerSearch),
    title: 'AdminHTML.SubscriptionV3.Addons.AddonFeature.feature01.name',
    description: 'AdminHTML.SubscriptionV3.Addons.AddonFeature.feature01.description',
    price: 39,
    allowTrial: true,
    advanceList: [
      'AdminHTML.SubscriptionV3.Addons.AddonFeature.feature01.advance01',
      'AdminHTML.SubscriptionV3.Addons.AddonFeature.feature01.advance02'
    ]
  },
  {
    name: 'aiPowerRecommendation',
    addonName: 'AI-powered-recommendation',
    image: getAssetURL(ADMIN_APP_ASSET_PATHS?.subscriptionV3?.recommendation),
    title: 'AdminHTML.SubscriptionV3.Addons.AddonFeature.feature02.name',
    description: 'AdminHTML.SubscriptionV3.Addons.AddonFeature.feature02.description',
    price: 39,
    allowTrial: true,
    advanceList: [
      'AdminHTML.SubscriptionV3.Addons.AddonFeature.feature02.advance01',
      'AdminHTML.SubscriptionV3.Addons.AddonFeature.feature02.advance02'
    ]
  },
  {
    name: 'visualMerchandising',
    addonName: 'visual-merchandising',
    image: getAssetURL(ADMIN_APP_ASSET_PATHS?.subscriptionV3?.visualMerchandising),
    title: 'AdminHTML.SubscriptionV3.Addons.AddonFeature.feature03.name',
    description: 'AdminHTML.SubscriptionV3.Addons.AddonFeature.feature03.description',
    price: 19,
    allowTrial: true,
    advanceList: ['AdminHTML.SubscriptionV3.Addons.AddonFeature.feature03.advance01']
  },
  {
    name: 'analytics',
    addonName: 'analytics',
    image: getAssetURL(ADMIN_APP_ASSET_PATHS?.subscriptionV3?.analytics),
    title: 'AdminHTML.SubscriptionV3.Addons.AddonFeature.feature05.name',
    description: 'AdminHTML.SubscriptionV3.Addons.AddonFeature.feature05.description',
    descriptionBackup: 'AdminHTML.SubscriptionV3.Addons.AddonFeature.feature05.descriptionBackup',
    price: 19,
    value: [30, 90, 180, 365], //720
    allowTrial: false,
    advanceList: [
      'AdminHTML.SubscriptionV3.Addons.AddonFeature.feature05.advance01',
      'AdminHTML.SubscriptionV3.Addons.AddonFeature.feature05.advance02',
      'AdminHTML.SubscriptionV3.Addons.AddonFeature.feature05.advance03'
    ]
  },
  {
    name: 'variantDisplay',
    addonName: 'variant-display',
    image: getAssetURL(ADMIN_APP_ASSET_PATHS?.subscriptionV3?.variantDisplay),
    title: 'AdminHTML.SubscriptionV3.Addons.AddonFeature.feature04.name',
    description: 'AdminHTML.SubscriptionV3.Addons.AddonFeature.feature04.description',
    price: 29,
    allowTrial: true,
    advanceList: ['AdminHTML.SubscriptionV3.Addons.AddonFeature.feature04.advance01']
  }
  // {
  //   name: 'support',
  //   title: 'AdminHTML.SubscriptionV3.Addons.AddonFeature.feature07.name',
  //   description: 'AdminHTML.SubscriptionV3.Addons.AddonFeature.feature07.description',
  //   price: 0,
  //   advanceList: [
  //     'AdminHTML.SubscriptionV3.Addons.AddonFeature.feature07.advance01',
  //     'AdminHTML.SubscriptionV3.Addons.AddonFeature.feature07.advance02'
  //   ]
  // }
];

export const ADDONS_INFO_V4 = [
  {
    name: 'aiPowerSearch',
    addonName: 'AI-powered-search',
    image: getAssetURL(ADMIN_APP_ASSET_PATHS?.subscriptionV3?.aiPowerSearch),
    title: 'AdminHTML.SubscriptionV4.Addons.AddonFeature.feature01.name',
    description: 'AdminHTML.SubscriptionV4.Addons.AddonFeature.feature01.description',
    price: 89,
    allowTrial: true,
    advanceList: [
      'AdminHTML.SubscriptionV4.Addons.AddonFeature.feature01.advance01',
      'AdminHTML.SubscriptionV4.Addons.AddonFeature.feature01.advance02'
    ]
  },
  {
    name: 'aiPowerRecommendation',
    addonName: 'AI-powered-recommendation',
    image: getAssetURL(ADMIN_APP_ASSET_PATHS?.subscriptionV3?.recommendation),
    title: 'AdminHTML.SubscriptionV4.Addons.AddonFeature.feature02.name',
    description: 'AdminHTML.SubscriptionV4.Addons.AddonFeature.feature02.description',
    price: 89,
    allowTrial: true,
    advanceList: [
      'AdminHTML.SubscriptionV4.Addons.AddonFeature.feature02.advance01',
      'AdminHTML.SubscriptionV4.Addons.AddonFeature.feature02.advance02'
    ]
  },
  {
    name: 'visualMerchandising',
    addonName: 'visual-merchandising',
    image: getAssetURL(ADMIN_APP_ASSET_PATHS?.subscriptionV3?.visualMerchandising),
    title: 'AdminHTML.SubscriptionV4.Addons.AddonFeature.feature03.name',
    description: 'AdminHTML.SubscriptionV4.Addons.AddonFeature.feature03.description',
    price: 39,
    allowTrial: true,
    advanceList: ['AdminHTML.SubscriptionV4.Addons.AddonFeature.feature03.advance01']
  },
  {
    name: 'variantDisplay',
    addonName: 'variant-display',
    image: getAssetURL(ADMIN_APP_ASSET_PATHS?.subscriptionV3?.variantDisplay),
    title: 'AdminHTML.SubscriptionV4.Addons.AddonFeature.feature04.name',
    description: 'AdminHTML.SubscriptionV4.Addons.AddonFeature.feature04.description',
    price: 49,
    allowTrial: true,
    advanceList: ['AdminHTML.SubscriptionV4.Addons.AddonFeature.feature04.advance01']
  }
];

export const ANALYTIC_LIMIT = {
  freemium: 7,
  basic: 90,
  essential: 180,
  professional: 365
};

export const PLAN_STATUS = [
  {
    status: 'trial',
    label: 'AdminHTML.SubscriptionV3.PlanStatus.status_Trial',
    type: 'attention'
  },
  {
    status: 'trialPackage',
    label: 'AdminHTML.SubscriptionV3.PlanStatus.status_Trial',
    type: 'attention'
  },
  {
    status: 'expiredSoon',
    label: 'AdminHTML.SubscriptionV3.PlanStatus.status_ExpiredSoon',
    type: 'attention'
  },
  {
    status: 'specialDiscount2021ExpiredSoon',
    label: 'AdminHTML.SubscriptionV3.PlanStatus.status_ExpiredSoon',
    type: 'attention'
  },
  {
    status: 'expired',
    label: 'AdminHTML.SubscriptionV3.PlanStatus.status_Expired',
    type: 'critical'
  },
  {
    status: 'subscribed',
    label: 'AdminHTML.SubscriptionV3.PlanStatus.status_Subscribe',
    type: 'success'
  },
  {
    status: 'exceededWithNotification',
    label: 'AdminHTML.SubscriptionV3.PlanStatus.status_Subscribe',
    type: 'success'
  },
  {
    status: 'exceeded',
    label: 'AdminHTML.SubscriptionV3.PlanStatus.status_Exceeded',
    type: 'critical'
  },
  {
    status: 'exceededWithNotification',
    label: 'AdminHTML.SubscriptionV3.PlanStatus.status_Exceeded',
    type: 'critical'
  },
  {
    status: 'specialDiscountExpiredSoon',
    label: 'AdminHTML.SubscriptionV3.PlanStatus.status_DiscountExpiring',
    type: 'attention'
  },
  {
    status: 'specialDiscountExpired',
    label: 'AdminHTML.SubscriptionV3.PlanStatus.status_Subscribe',
    type: 'success'
  },
  {
    status: 'oldSpecialDiscountExpired',
    label: 'AdminHTML.SubscriptionV3.PlanStatus.status_Expired',
    type: 'critical'
  },
  {
    status: 'regularExpiredSoon',
    label: 'AdminHTML.SubscriptionV3.PlanStatus.status_DiscountExpiring',
    type: 'attention'
  },
  {
    status: 'regularExpired',
    label: 'AdminHTML.SubscriptionV3.PlanStatus.status_Expired',
    type: 'critical'
  }
];

export const issuesChoices = [
  {
    label: 'AdminHTML.SubscriptionV3.UnsubscribeFeedbackModal.reason01',
    value: 'notMeetNeed',
    tracking: 'Does not meet my needs.',
    code: '1'
  },
  {
    label: 'AdminHTML.SubscriptionV3.UnsubscribeFeedbackModal.reason02',
    value: 'hardToUse',
    tracking: 'Feature is not performing well.',
    code: '2'
  },
  {
    label: 'AdminHTML.SubscriptionV3.UnsubscribeFeedbackModal.reason03',
    value: 'notNeedAnymore',
    tracking: `Not needed any more.`,
    code: '3'
  },
  {
    label: 'AdminHTML.SubscriptionV3.UnsubscribeFeedbackModal.reason04',
    value: 'expensive',
    tracking: 'Feature is not worth the cost.',
    code: '4'
  },
  {
    label: 'AdminHTML.SubscriptionV3.UnsubscribeFeedbackModal.reason05',
    value: 'others',
    tracking: 'Others',
    code: '6'
  }
];

export const ANALYTICS_ADDON = [
  {
    value: '90',
    name: 'analytics-90-days',
    price: 19,
    label: 'AdminHTML.SubscriptionV3.Addons.Analytics.analytics02'
  },
  {
    value: '180',
    name: 'analytics-180-days',
    price: 29,
    label: 'AdminHTML.SubscriptionV3.Addons.Analytics.analytics03'
  },
  {
    value: '365',
    name: 'analytics-365-days',
    price: 49,
    label: 'AdminHTML.SubscriptionV3.Addons.Analytics.analytics04'
  }
  // {
  //   value: '720',
  //   name: 'analytics-720-days',
  //   price: 39,
  //   label: 'AdminHTML.SubscriptionV3.Addons.Analytics.analytics05'
  // }
];

export const REVIEW_ADDON_CONTENT = [
  {
    name: 'aiPowerSearch',
    section01: [
      {
        label: 'AdminHTML.SubscriptionV3.ReviewAddon.aiPowerSearch.section01_Column01_Label',
        content: 'AdminHTML.SubscriptionV3.ReviewAddon.aiPowerSearch.section01_Column01_Content',
        isNew: true
      },
      {
        label: 'AdminHTML.SubscriptionV3.ReviewAddon.aiPowerSearch.section01_Column02_Label',
        content: 'AdminHTML.SubscriptionV3.ReviewAddon.aiPowerSearch.section01_Column02_Content'
      },
      {
        label: 'AdminHTML.SubscriptionV3.ReviewAddon.aiPowerSearch.section01_Column03_Label',
        content: 'AdminHTML.SubscriptionV3.ReviewAddon.aiPowerSearch.section01_Column03_Content'
      }
    ],
    section02: [
      getAssetURL(ADMIN_APP_ASSET_PATHS?.subscriptionV3?.addon?.enhanceIcon),
      getAssetURL(ADMIN_APP_ASSET_PATHS?.subscriptionV3?.addon?.intelligenceIcon),
      getAssetURL(ADMIN_APP_ASSET_PATHS?.subscriptionV3?.addon?.autocompleteIcon)
    ],
    section03Label: 'AdminHTML.SubscriptionV3.ReviewAddon.aiPowerSearch.section03_Label',
    section03LabelSubtext: 'AdminHTML.SubscriptionV3.ReviewAddon.aiPowerSearch.section03_Label_t',
    section03: [
      'AdminHTML.SubscriptionV3.ReviewAddon.aiPowerSearch.section03_Content01',
      'AdminHTML.SubscriptionV3.ReviewAddon.aiPowerSearch.section03_Content02',
      'AdminHTML.SubscriptionV3.ReviewAddon.aiPowerSearch.section03_Content03'
    ],
    section03SubText: ['AdminHTML.SubscriptionV3.ReviewAddon.aiPowerSearch.section03_Content01_t'],
    section04: getAssetURL(ADMIN_APP_ASSET_PATHS?.subscriptionV3?.addon?.aiPowerSearchBanner)
  },
  {
    name: 'aiPowerRecommendation',
    section01: [
      {
        label:
          'AdminHTML.SubscriptionV3.ReviewAddon.aiPowerRecommendation.section01_Column01_Label',
        content:
          'AdminHTML.SubscriptionV3.ReviewAddon.aiPowerRecommendation.section01_Column01_Content'
      },
      {
        label:
          'AdminHTML.SubscriptionV3.ReviewAddon.aiPowerRecommendation.section01_Column02_Label',
        content:
          'AdminHTML.SubscriptionV3.ReviewAddon.aiPowerRecommendation.section01_Column02_Content'
      },
      {
        label:
          'AdminHTML.SubscriptionV3.ReviewAddon.aiPowerRecommendation.section01_Column03_Label',
        content:
          'AdminHTML.SubscriptionV3.ReviewAddon.aiPowerRecommendation.section01_Column03_Content'
      }
    ],
    section02: [
      getAssetURL(ADMIN_APP_ASSET_PATHS?.subscriptionV3?.addon?.aiIcon),
      getAssetURL(ADMIN_APP_ASSET_PATHS?.subscriptionV3?.addon?.quickSetupIcon),
      getAssetURL(ADMIN_APP_ASSET_PATHS?.subscriptionV3?.addon?.themeCompatible)
    ],
    section03Label: 'AdminHTML.SubscriptionV3.ReviewAddon.aiPowerRecommendation.section03_Label',
    section03: [
      'AdminHTML.SubscriptionV3.ReviewAddon.aiPowerRecommendation.section03_Content01',
      'AdminHTML.SubscriptionV3.ReviewAddon.aiPowerRecommendation.section03_Content02',
      'AdminHTML.SubscriptionV3.ReviewAddon.aiPowerRecommendation.section03_Content03'
    ],
    section04: getAssetURL(
      ADMIN_APP_ASSET_PATHS?.subscriptionV3?.addon?.aiPowerRecommendationBanner
    )
  },
  {
    name: 'visualMerchandising',
    section01: [
      {
        isNew: true,
        label: 'AdminHTML.SubscriptionV3.ReviewAddon.visualMerchandising.section01_Column01_Label',
        content:
          'AdminHTML.SubscriptionV3.ReviewAddon.visualMerchandising.section01_Column01_Content'
      },
      {
        label: 'AdminHTML.SubscriptionV3.ReviewAddon.visualMerchandising.section01_Column02_Label',
        content:
          'AdminHTML.SubscriptionV3.ReviewAddon.visualMerchandising.section01_Column02_Content'
      }
    ],
    section02: [
      getAssetURL(ADMIN_APP_ASSET_PATHS?.subscriptionV3?.addon?.placement),
      getAssetURL(ADMIN_APP_ASSET_PATHS?.subscriptionV3?.addon?.dynamicRule),
      getAssetURL(ADMIN_APP_ASSET_PATHS?.subscriptionV3?.addon?.easySetup)
    ],
    section03Label: 'AdminHTML.SubscriptionV3.ReviewAddon.visualMerchandising.section03_Label',
    section03: [
      'AdminHTML.SubscriptionV3.ReviewAddon.visualMerchandising.section03_Content01',
      'AdminHTML.SubscriptionV3.ReviewAddon.visualMerchandising.section03_Content02',
      'AdminHTML.SubscriptionV3.ReviewAddon.visualMerchandising.section03_Content03',
      'AdminHTML.SubscriptionV3.ReviewAddon.visualMerchandising.section03_Content04',
      'AdminHTML.SubscriptionV3.ReviewAddon.visualMerchandising.section03_Content05',
      'AdminHTML.SubscriptionV3.ReviewAddon.visualMerchandising.section03_Content06'
    ],
    section03SubText: [
      'AdminHTML.SubscriptionV3.ReviewAddon.visualMerchandising.section03_Content01_t',
      'AdminHTML.SubscriptionV3.ReviewAddon.visualMerchandising.section03_Content02_t',
      'AdminHTML.SubscriptionV3.ReviewAddon.visualMerchandising.section03_Content03_t',
      'AdminHTML.SubscriptionV3.ReviewAddon.visualMerchandising.section03_Content04_t',
      'AdminHTML.SubscriptionV3.ReviewAddon.visualMerchandising.section03_Content05_t',
      'AdminHTML.SubscriptionV3.ReviewAddon.visualMerchandising.section03_Content06_t'
    ],
    section04: getAssetURL(ADMIN_APP_ASSET_PATHS?.subscriptionV3?.addon?.visualMerchandisingBanner)
  },
  {
    name: 'syncFrequency',
    section01: [
      {
        label: 'AdminHTML.SubscriptionV3.ReviewAddon.syncFrequency.section01_Column01_Label'
      },
      {
        label: 'AdminHTML.SubscriptionV3.ReviewAddon.syncFrequency.section01_Column02_Label'
      }
    ],
    section02: [
      getAssetURL(ADMIN_APP_ASSET_PATHS?.subscriptionV3?.addon?.quickIcon),
      getAssetURL(ADMIN_APP_ASSET_PATHS?.subscriptionV3?.addon?.priorityIcon),
      getAssetURL(ADMIN_APP_ASSET_PATHS?.subscriptionV3?.addon?.saveIcon)
    ],
    section04: getAssetURL(ADMIN_APP_ASSET_PATHS?.subscriptionV3?.addon?.syncFrequencyBanner)
  },
  {
    name: 'analytics',
    section01: [
      {
        label: 'AdminHTML.SubscriptionV3.ReviewAddon.analytics.section01_Column01_Label'
      },
      {
        label: 'AdminHTML.SubscriptionV3.ReviewAddon.analytics.section01_Column02_Label'
      },
      {
        label: 'AdminHTML.SubscriptionV3.ReviewAddon.analytics.section01_Column03_Label'
      }
    ],
    section02: [
      getAssetURL(ADMIN_APP_ASSET_PATHS?.subscriptionV3?.addon?.calenderIcon),
      getAssetURL(ADMIN_APP_ASSET_PATHS?.subscriptionV3?.addon?.comparisonIcon),
      getAssetURL(ADMIN_APP_ASSET_PATHS?.subscriptionV3?.addon?.exportIcon)
    ],
    section03Label: 'AdminHTML.SubscriptionV3.ReviewAddon.analytics.section03_Label',
    section03: [
      'AdminHTML.SubscriptionV3.ReviewAddon.analytics.section03_Content01',
      'AdminHTML.SubscriptionV3.ReviewAddon.analytics.section03_Content02',
      'AdminHTML.SubscriptionV3.ReviewAddon.analytics.section03_Content03'
    ],
    section04: getAssetURL(ADMIN_APP_ASSET_PATHS?.subscriptionV3?.addon?.analyticsBanner)
  },
  {
    name: 'variantDisplay',
    section01: [
      {
        label: 'AdminHTML.SubscriptionV3.ReviewAddon.variantDisplay.section01_Column01_Label'
      },
      {
        label: 'AdminHTML.SubscriptionV3.ReviewAddon.variantDisplay.section01_Column02_Label'
      }
    ],
    section02: [
      getAssetURL(ADMIN_APP_ASSET_PATHS?.subscriptionV3?.addon?.variantIcon),
      getAssetURL(ADMIN_APP_ASSET_PATHS?.subscriptionV3?.addon?.clockIcon),
      getAssetURL(ADMIN_APP_ASSET_PATHS?.subscriptionV3?.addon?.saleIcon)
    ],
    section03Label: 'AdminHTML.SubscriptionV3.ReviewAddon.variantDisplay.section03_Label',
    section03: [
      'AdminHTML.SubscriptionV3.ReviewAddon.variantDisplay.section03_Content01',
      'AdminHTML.SubscriptionV3.ReviewAddon.variantDisplay.section03_Content02',
      'AdminHTML.SubscriptionV3.ReviewAddon.variantDisplay.section03_Content03'
    ],
    section04: getAssetURL(ADMIN_APP_ASSET_PATHS?.subscriptionV3?.addon?.variantDisplayBanner)
  }
];
// aiPowerSearch
// aiPowerRecommendation
// analytics
// variantDisplay
// visualMerchandising
export const REVIEW_ADDON_CONTENT_V2 = [
  {
    name: 'aiPowerSearch',
    url: URL['AddOn_Search'],
    title: 'AdminHTML.SubscriptionV3.ReviewAddonV2.aiPowerSearch.title',
    description: 'AdminHTML.SubscriptionV3.ReviewAddonV2.aiPowerSearch.description',
    blockItems: [
      { label: 'AdminHTML.SubscriptionV3.ReviewAddonV2.aiPowerSearch.item_product', isNew: true },
      { label: 'AdminHTML.SubscriptionV3.ReviewAddonV2.aiPowerSearch.item_semantic' },
      { label: 'AdminHTML.SubscriptionV3.ReviewAddonV2.aiPowerSearch.item_synonym' },
      { label: 'AdminHTML.SubscriptionV3.ReviewAddonV2.aiPowerSearch.item_suggestion' }
    ],
    blockItemsCol: 2,
    slides: [
      {
        title: 'AdminHTML.SubscriptionV3.ReviewAddonV2.aiPowerSearch.item_sli_synonym_title',
        des: 'AdminHTML.SubscriptionV3.ReviewAddonV2.aiPowerSearch.item_sli_synonym_des',
        img: getAssetURL(ADMIN_APP_ASSET_PATHS?.subscriptionV3?.addon?.slide?.itemSliSynonymDes)
      },
      {
        title: 'AdminHTML.SubscriptionV3.ReviewAddonV2.aiPowerSearch.item_sli_product_title',
        des: 'AdminHTML.SubscriptionV3.ReviewAddonV2.aiPowerSearch.item_sli_product_des',
        img: getAssetURL(ADMIN_APP_ASSET_PATHS?.subscriptionV3?.addon?.slide?.itemSliProductDes)
      },
      {
        title: 'AdminHTML.SubscriptionV3.ReviewAddonV2.aiPowerSearch.item_sli_semantic_title',
        des: 'AdminHTML.SubscriptionV3.ReviewAddonV2.aiPowerSearch.item_sli_semantic_des',
        img: getAssetURL(ADMIN_APP_ASSET_PATHS?.subscriptionV3?.addon?.slide?.itemSliSemanticDes)
      },
      {
        title: 'AdminHTML.SubscriptionV3.ReviewAddonV2.aiPowerSearch.item_sli_suggest_title',
        des: 'AdminHTML.SubscriptionV3.ReviewAddonV2.aiPowerSearch.item_sli_suggest_des',
        img: getAssetURL(ADMIN_APP_ASSET_PATHS?.subscriptionV3?.addon?.slide?.itemSliSuggestDes)
      }
    ]
  },
  {
    name: 'aiPowerRecommendation',
    url: URL['AddOn_Recommend'],
    title: 'AdminHTML.SubscriptionV3.ReviewAddonV2.aiPowerRecommendation.title',
    description: 'AdminHTML.SubscriptionV3.ReviewAddonV2.aiPowerRecommendation.description',
    blockItems: [
      { label: 'AdminHTML.SubscriptionV3.ReviewAddonV2.aiPowerRecommendation.item_freq' },
      { label: 'AdminHTML.SubscriptionV3.ReviewAddonV2.aiPowerRecommendation.item_related' },
      { label: 'AdminHTML.SubscriptionV3.ReviewAddonV2.aiPowerRecommendation.item_recent' }
    ],
    blockItemsCol: 2,
    slides: [
      {
        title: 'AdminHTML.SubscriptionV3.ReviewAddonV2.aiPowerRecommendation.item_sli_freq_title',
        des: 'AdminHTML.SubscriptionV3.ReviewAddonV2.aiPowerRecommendation.item_sli_freq_des',
        img: getAssetURL(ADMIN_APP_ASSET_PATHS?.subscriptionV3?.addon?.slide?.itemSliFreqDes)
      },
      {
        title:
          'AdminHTML.SubscriptionV3.ReviewAddonV2.aiPowerRecommendation.item_sli_related_title',
        des: 'AdminHTML.SubscriptionV3.ReviewAddonV2.aiPowerRecommendation.item_sli_related_des',
        img: getAssetURL(ADMIN_APP_ASSET_PATHS?.subscriptionV3?.addon?.slide?.itemSliRelatedDes)
      },
      {
        title: 'AdminHTML.SubscriptionV3.ReviewAddonV2.aiPowerRecommendation.item_sli_recent_title',
        des: 'AdminHTML.SubscriptionV3.ReviewAddonV2.aiPowerRecommendation.item_sli_recent_des',
        img: getAssetURL(ADMIN_APP_ASSET_PATHS?.subscriptionV3?.addon?.slide?.itemSliRecentDes)
      }
    ]
  },
  {
    name: 'analytics',
    url: URL['AddOn_Analytic'],
    title: 'AdminHTML.SubscriptionV3.ReviewAddonV2.analytics.title',
    description: 'AdminHTML.SubscriptionV3.ReviewAddonV2.analytics.description',
    blockItems: [
      { label: 'AdminHTML.SubscriptionV3.ReviewAddonV2.analytics.item_90' },
      { label: 'AdminHTML.SubscriptionV3.ReviewAddonV2.analytics.item_180' },
      { label: 'AdminHTML.SubscriptionV3.ReviewAddonV2.analytics.item_365' }
    ],
    blockItemsCol: 2,
    slides: [
      {
        title: 'AdminHTML.SubscriptionV3.ReviewAddonV2.analytics.item_sli_extend_title',
        des: 'AdminHTML.SubscriptionV3.ReviewAddonV2.analytics.item_sli_extend_des',
        img: getAssetURL(ADMIN_APP_ASSET_PATHS?.subscriptionV3?.addon?.slide?.itemSliExtendDes)
      },
      {
        title: 'AdminHTML.SubscriptionV3.ReviewAddonV2.analytics.item_sli_insight_title',
        des: 'AdminHTML.SubscriptionV3.ReviewAddonV2.analytics.item_sli_insight_des',
        img: getAssetURL(ADMIN_APP_ASSET_PATHS?.subscriptionV3?.addon?.slide?.itemSliInsightDes)
      },
      {
        title: 'AdminHTML.SubscriptionV3.ReviewAddonV2.analytics.item_sli_trend_title',
        des: 'AdminHTML.SubscriptionV3.ReviewAddonV2.analytics.item_sli_trend_des',
        img: getAssetURL(ADMIN_APP_ASSET_PATHS?.subscriptionV3?.addon?.slide?.itemSliTrendDes)
      }
    ]
  },
  {
    name: 'variantDisplay',
    url: URL['AddOn_Variant'],
    title: 'AdminHTML.SubscriptionV3.ReviewAddonV2.variantDisplay.title',
    description: 'AdminHTML.SubscriptionV3.ReviewAddonV2.variantDisplay.description',
    blockItems: [
      { label: 'AdminHTML.SubscriptionV3.ReviewAddonV2.variantDisplay.item_display' },
      { label: 'AdminHTML.SubscriptionV3.ReviewAddonV2.variantDisplay.item_optimize' }
    ],
    blockItemsCol: 1,
    slides: [
      {
        title: 'AdminHTML.SubscriptionV3.ReviewAddonV2.variantDisplay.item_sli_increase_title',
        des: 'AdminHTML.SubscriptionV3.ReviewAddonV2.variantDisplay.item_sli_increase_des',
        img: getAssetURL(ADMIN_APP_ASSET_PATHS?.subscriptionV3?.addon?.slide?.itemSliIncreaseDes)
      },
      {
        title: 'AdminHTML.SubscriptionV3.ReviewAddonV2.variantDisplay.item_sli_optimize_title',
        des: 'AdminHTML.SubscriptionV3.ReviewAddonV2.variantDisplay.item_sli_optimize_des',
        img: getAssetURL(ADMIN_APP_ASSET_PATHS?.subscriptionV3?.addon?.slide?.itemSliOptimizeDes)
      }
    ]
  },
  {
    name: 'visualMerchandising',
    url: URL['AddOn_Merchandising'],
    title: 'AdminHTML.SubscriptionV3.ReviewAddonV2.visualMerchandising.title',
    description: 'AdminHTML.SubscriptionV3.ReviewAddonV2.visualMerchandising.description',
    subDescription: {
      content: 'AdminHTML.SubscriptionV3.ReviewAddonV2.visualMerchandising.subDescription',
      boldContent: 100
    },
    blockItems: [
      { label: 'AdminHTML.SubscriptionV3.ReviewAddonV2.visualMerchandising.item_pin' },
      { label: 'AdminHTML.SubscriptionV3.ReviewAddonV2.visualMerchandising.item_boost' },
      { label: 'AdminHTML.SubscriptionV3.ReviewAddonV2.visualMerchandising.item_demote' },
      { label: 'AdminHTML.SubscriptionV3.ReviewAddonV2.visualMerchandising.item_hide' },
      { label: 'AdminHTML.SubscriptionV3.ReviewAddonV2.visualMerchandising.item_filter' },
      { label: 'AdminHTML.SubscriptionV3.ReviewAddonV2.visualMerchandising.item_banner' }
    ],

    blockItemsCol: 3,
    slides: [
      {
        title: 'AdminHTML.SubscriptionV3.ReviewAddonV2.visualMerchandising.item_sli_pin_title',
        des: 'AdminHTML.SubscriptionV3.ReviewAddonV2.visualMerchandising.item_sli_pin_des',
        img: getAssetURL(ADMIN_APP_ASSET_PATHS?.subscriptionV3?.addon?.slide?.itemSliPinDes)
      },
      {
        title: 'AdminHTML.SubscriptionV3.ReviewAddonV2.visualMerchandising.item_sli_boost_title',
        des: 'AdminHTML.SubscriptionV3.ReviewAddonV2.visualMerchandising.item_sli_boost_des',
        img: getAssetURL(ADMIN_APP_ASSET_PATHS?.subscriptionV3?.addon?.slide?.itemSliBoostDes)
      },
      {
        title: 'AdminHTML.SubscriptionV3.ReviewAddonV2.visualMerchandising.item_sli_demote_title',
        des: 'AdminHTML.SubscriptionV3.ReviewAddonV2.visualMerchandising.item_sli_demote_des',
        img: getAssetURL(ADMIN_APP_ASSET_PATHS?.subscriptionV3?.addon?.slide?.itemSliDemoteDes)
      },
      {
        title: 'AdminHTML.SubscriptionV3.ReviewAddonV2.visualMerchandising.item_sli_hide_title',
        des: 'AdminHTML.SubscriptionV3.ReviewAddonV2.visualMerchandising.item_sli_hide_des',
        img: getAssetURL(ADMIN_APP_ASSET_PATHS?.subscriptionV3?.addon?.slide?.itemSliHideDes)
      },
      {
        title: 'AdminHTML.SubscriptionV3.ReviewAddonV2.visualMerchandising.item_sli_filter_title',
        des: 'AdminHTML.SubscriptionV3.ReviewAddonV2.visualMerchandising.item_sli_filter_des',
        img: getAssetURL(ADMIN_APP_ASSET_PATHS?.subscriptionV3?.addon?.slide?.itemSliFilterDes)
      },
      {
        title: 'AdminHTML.SubscriptionV3.ReviewAddonV2.visualMerchandising.item_sli_banner_title',
        des: 'AdminHTML.SubscriptionV3.ReviewAddonV2.visualMerchandising.item_sli_banner_des',
        img: getAssetURL(ADMIN_APP_ASSET_PATHS?.subscriptionV3?.addon?.slide?.itemSliBannerDes)
      }
    ]
  }
];

export const DISCOUNT_ERRORS = {
  discount_expired: 'AdminHTML.SubscriptionV3.DiscountCodeError.discountCodeExpired',
  invalid_discount: 'AdminHTML.SubscriptionV3.DiscountCodeError.invalidDiscount',
  not_eligible_discount: 'AdminHTML.SubscriptionV3.DiscountCodeError.notEligible',
  only_apply_addon: 'AdminHTML.SubscriptionV3.DiscountCodeError.onlyApplyAddon',
  not_apply_addon: 'AdminHTML.SubscriptionV3.DiscountCodeError.notApplyAddon'
};

export const ERROR_TURBO_CAMPAIGN = 'Please upgrade to TURBO to apply this code.';

export const FEATURE_COMPARISON = [
  'search',
  'visualMerchandising',
  'recommendation',
  'personalization',
  'analytics',
  'advancedProductFilter',
  'themeIntegration',
  'sync',
  'support',
  'compliance'
];

export const FEATURE_COMPARISON_V4 = [
  'productNumber',
  'search',
  'advancedProductFilter',
  'visualMerchandising',
  'recommendation',
  'personalization',
  'analytics',
  'dynamicProductListing',
  'sync',
  'appVisualization',
  'support',
  'globalSales',
  'b2B',
  'preOrder'
];

// DATA TABLE OF LIST FEATURE PACKAGE COMPARISON
// Value is addon price with package
//            if value = 0 => auto applied
//            if value = -1 => feature will coming soon
export const DATA_BY_FEATURE = {
  search: [
    {
      content: 'AdminHTML.SubscriptionV3.PackageComparison.searchContent01',
      subtext: [
        'AdminHTML.SubscriptionV3.PackageComparison.searchContent01_Tex01',
        'AdminHTML.SubscriptionV3.PackageComparison.searchContent01_Tex02',
        'AdminHTML.SubscriptionV3.PackageComparison.searchContent01_Tex03',
        'AdminHTML.SubscriptionV3.PackageComparison.searchContent01_Tex04',
        'AdminHTML.SubscriptionV3.PackageComparison.searchContent16'
      ],
      value: [39, 0, 0],
      isRising: true
    },
    {
      content: 'AdminHTML.SubscriptionV3.PackageComparison.searchContent02',
      subtext: [],
      value: [0, 0, 0]
    },
    {
      content: 'AdminHTML.SubscriptionV3.PackageComparison.searchContent03',
      subtext: [],
      value: [0, 0, 0]
    },
    {
      content: 'AdminHTML.SubscriptionV3.PackageComparison.searchContent04',
      subtext: [],
      value: [0, 0, 0]
    },
    {
      content: 'AdminHTML.SubscriptionV3.PackageComparison.searchContent05',
      subtext: [],
      value: [0, 0, 0]
    },
    {
      content: 'AdminHTML.SubscriptionV3.PackageComparison.searchContent06',
      subtext: [],
      value: [0, 0, 0]
    },
    {
      content: 'AdminHTML.SubscriptionV3.PackageComparison.searchContent07',
      subtext: [],
      value: [0, 0, 0]
    },
    {
      content: 'AdminHTML.SubscriptionV3.PackageComparison.searchContent08',
      subtext: [],
      value: [0, 0, 0]
    },
    {
      content: 'AdminHTML.SubscriptionV3.PackageComparison.searchContent09',
      subtext: [],
      value: [0, 0, 0]
    },
    {
      content: 'AdminHTML.SubscriptionV3.PackageComparison.searchContent10',
      subtext: [],
      value: [0, 0, 0]
    },
    {
      content: 'AdminHTML.SubscriptionV3.PackageComparison.searchContent11',
      subtext: [],
      value: [0, 0, 0]
    },
    {
      content: 'AdminHTML.SubscriptionV3.PackageComparison.searchContent12',
      subtext: [],
      value: [0, 0, 0]
    },
    {
      content: 'AdminHTML.SubscriptionV3.PackageComparison.searchContent13',
      subtext: [],
      value: [0, 0, 0]
    },
    {
      content: 'AdminHTML.SubscriptionV3.PackageComparison.searchContent14',
      subtext: [],
      value: [0, 0, 0]
    },
    {
      content: 'AdminHTML.SubscriptionV3.PackageComparison.searchContent15',
      subtext: [],
      value: [0, 0, 0]
    }
  ],
  visualMerchandising: [
    {
      content: 'AdminHTML.SubscriptionV3.PackageComparison.visualMerchandisingContent01',
      subtext: [],
      value: [19, 19, 0]
    },
    {
      content: 'AdminHTML.SubscriptionV3.PackageComparison.visualMerchandisingContent02',
      subtext: [],
      value: [19, 0, 0]
    },
    {
      content: 'AdminHTML.SubscriptionV3.PackageComparison.visualMerchandisingContent03',
      subtext: [],
      value: [0, 0, 0],
      isRising: true
    },
    {
      content: 'AdminHTML.SubscriptionV3.PackageComparison.visualMerchandisingContent04',
      subtext: [],
      value: [0, 0, 0],
      isRising: true
    }
  ],
  recommendation: [
    {
      content: 'AdminHTML.SubscriptionV3.PackageComparison.recommendationContent01',
      subtext: [
        'AdminHTML.SubscriptionV3.PackageComparison.recommendationContent01_Text01',
        'AdminHTML.SubscriptionV3.PackageComparison.recommendationContent01_Text02',
        'AdminHTML.SubscriptionV3.PackageComparison.recommendationContent01_Text03'
      ],
      value: [39, 0, 0]
    },
    {
      content: 'AdminHTML.SubscriptionV3.PackageComparison.recommendationContent02',
      subtext: [],
      value: [0, 0, 0]
    },
    {
      content: 'AdminHTML.SubscriptionV3.PackageComparison.recommendationContent03',
      subtext: [],
      value: [0, 0, 0]
    },
    {
      content: 'AdminHTML.SubscriptionV3.PackageComparison.recommendationContent04',
      subtext: [],
      value: [0, 0, 0]
    },
    {
      content: 'AdminHTML.SubscriptionV3.PackageComparison.recommendationContent05',
      subtext: [],
      value: [0, 0, 0]
    },
    {
      content: 'AdminHTML.SubscriptionV3.PackageComparison.recommendationContent06',
      subtext: [],
      value: [0, 0, 0]
    },
    {
      content: 'AdminHTML.SubscriptionV3.PackageComparison.recommendationContent062',
      subtext: [],
      value: [0, 0, 0]
    },
    {
      content: 'AdminHTML.SubscriptionV3.PackageComparison.recommendationContent07',
      subtext: [],
      value: [0, 0, 0],
      isRising: true
    },
    {
      content: 'AdminHTML.SubscriptionV3.PackageComparison.recommendationContent08',
      subtext: [],
      value: [0, 0, 0]
    },
    {
      content: 'AdminHTML.SubscriptionV3.PackageComparison.recommendationContent09',
      subtext: [],
      value: [-1, 0, 0],
      isRising: true
    },
    {
      content: 'AdminHTML.SubscriptionV3.PackageComparison.recommendationContent10',
      subtext: [],
      value: [-1, -1, 0],
      isRising: true
    }
  ],
  personalization: [
    {
      content: 'AdminHTML.SubscriptionV3.PackageComparison.personalizationContent01',
      subtext: [],
      value: [-1, -1, 0]
    },
    {
      content: 'AdminHTML.SubscriptionV3.PackageComparison.personalizationContent02',
      subtext: [],
      value: [-1, -1, 0]
    },
    {
      content: 'AdminHTML.SubscriptionV3.PackageComparison.personalizationContent03',
      subtext: [],
      value: [-1, -1, 0]
    }
  ],
  analytics: [
    {
      content: 'AdminHTML.SubscriptionV3.PackageComparison.analyticsContent01',
      subtext: [],
      value: [19, 0, 0],
      isRising: true
    },
    {
      content: 'AdminHTML.SubscriptionV3.PackageComparison.analyticsContent02',
      subtext: [],
      value: [29, 29, 0],
      isRising: true
    },
    {
      content: 'AdminHTML.SubscriptionV3.PackageComparison.analyticsContent03',
      subtext: [],
      value: [49, 49, 49],
      isRising: true
    },
    {
      content: 'AdminHTML.SubscriptionV3.PackageComparison.analyticsContent04',
      subtext: [],
      value: [0, 0, 0]
    },
    {
      content: 'AdminHTML.SubscriptionV3.PackageComparison.analyticsContent05',
      subtext: [],
      value: [0, 0, 0]
    },
    {
      content: 'AdminHTML.SubscriptionV3.PackageComparison.analyticsContent06',
      subtext: [],
      value: [0, 0, 0]
    },
    {
      content: 'AdminHTML.SubscriptionV3.PackageComparison.analyticsContent07',
      subtext: [],
      value: [0, 0, 0]
    },
    {
      content: 'AdminHTML.SubscriptionV3.PackageComparison.analyticsContent08',
      subtext: [],
      value: [0, 0, 0]
    },
    {
      content: 'AdminHTML.SubscriptionV3.PackageComparison.analyticsContent09',
      subtext: [],
      value: [0, 0, 0]
    }
  ],
  advancedProductFilter: [
    {
      content: 'AdminHTML.SubscriptionV3.PackageComparison.apfContent01',
      subtext: [],
      value: [0, 0, 0]
    },
    {
      content: 'AdminHTML.SubscriptionV3.PackageComparison.apfContent02',
      subtext: [],
      value: [0, 0, 0]
    },
    {
      content: 'AdminHTML.SubscriptionV3.PackageComparison.apfContent03',
      subtext: [],
      value: [0, 0, 0]
    },
    {
      content: 'AdminHTML.SubscriptionV3.PackageComparison.apfContent04',
      subtext: [],
      value: [0, 0, 0]
    },
    {
      content: 'AdminHTML.SubscriptionV3.PackageComparison.apfContent05',
      subtext: [],
      value: [0, 0, 0]
    },
    {
      content: 'AdminHTML.SubscriptionV3.PackageComparison.apfContent06',
      subtext: [],
      value: [0, 0, 0]
    },
    {
      content: 'AdminHTML.SubscriptionV3.PackageComparison.apfContent07',
      subtext: [],
      value: [0, 0, 0]
    },
    {
      content: 'AdminHTML.SubscriptionV3.PackageComparison.apfContent08',
      subtext: [],
      value: [0, 0, 0]
    },
    {
      content: 'AdminHTML.SubscriptionV3.PackageComparison.apfContent09',
      subtext: [],
      value: [0, 0, 0]
    },
    {
      content: 'AdminHTML.SubscriptionV3.PackageComparison.apfContent10',
      subtext: [],
      value: [0, 0, 0]
    },
    {
      content: 'AdminHTML.SubscriptionV3.PackageComparison.apfContent11',
      subtext: [],
      value: [0, 0, 0]
    }
  ],
  themeIntegration: [
    {
      content: 'AdminHTML.SubscriptionV3.PackageComparison.themeIntegrationContent01',
      subtext: [],
      value: [0, 0, 0]
    },
    {
      content: 'AdminHTML.SubscriptionV3.PackageComparison.themeIntegrationContent02',
      subtext: [],
      value: [0, 0, 0]
    },
    {
      content: 'AdminHTML.SubscriptionV3.PackageComparison.themeIntegrationContent03',
      subtext: [],
      value: [0, 0, 0]
    }
  ],
  sync: [
    {
      content: 'AdminHTML.SubscriptionV3.PackageComparison.syncContent01',
      subtext: [],
      value: [0, 0, 0]
    },
    {
      content: 'AdminHTML.SubscriptionV3.PackageComparison.syncContent02',
      subtext: [],
      value: [0, 0, 0]
    },
    {
      content: 'AdminHTML.SubscriptionV3.PackageComparison.syncContent03',
      subtext: [],
      value: [0, 0, 0]
    }
  ],
  support: [
    {
      content: 'AdminHTML.SubscriptionV3.PackageComparison.supportContent01',
      contentPlus: 'AdminHTML.SubscriptionV3.PackageComparison.supportPlusContent',
      subtext: [],
      value: [0, 0, 0]
    },
    {
      content: 'AdminHTML.SubscriptionV3.PackageComparison.supportContent02',
      contentPlus: 'AdminHTML.SubscriptionV3.PackageComparison.supportPlusContent',
      subtext: [],
      value: [
        'AdminHTML.SubscriptionV3.PackageComparison.supportShopifyPlus',
        'AdminHTML.SubscriptionV3.PackageComparison.supportShopifyPlus',
        'AdminHTML.SubscriptionV3.PackageComparison.supportShopifyPlus'
      ]
    },
    {
      content: 'AdminHTML.SubscriptionV4.PackageComparison.supportContent04',
      contentPlus: 'AdminHTML.SubscriptionV4.PackageComparison.supportContent04',
      subtext: [],
      value: [-1, -1, 0]
    }
  ],
  compliance: [
    {
      content: 'AdminHTML.SubscriptionV3.PackageComparison.complianceContent01',
      subtext: [],
      value: [0, 0, 0]
    },
    {
      content: 'AdminHTML.SubscriptionV3.PackageComparison.complianceContent02',
      subtext: [],
      value: [0, 0, 0]
    },
    {
      content: 'AdminHTML.SubscriptionV3.PackageComparison.complianceContent03',
      subtext: [],
      value: [0, 0, 0]
    }
  ]
};

// DATA TABLE OF LIST FEATURE PACKAGE COMPARISON V4
// Value is addon price with package
//            if value = 0 => auto applied
//            if value = -1 => feature will coming soon
export const DATA_BY_FEATURE_V4 = {
  productNumber: [
    {
      content: 'AdminHTML.SubscriptionV4.PackageComparison.productNumberContent01',
      values: [
        'AdminHTML.SubscriptionV4.PackageComparison.productNumberContent01_Freemium',
        'AdminHTML.SubscriptionV4.PackageComparison.productNumberContent01_Advance',
        'AdminHTML.SubscriptionV4.PackageComparison.productNumberContent01_Advance',
        'AdminHTML.SubscriptionV4.PackageComparison.productNumberContent01_Advance'
      ]
    }
  ],
  search: [
    {
      content: 'AdminHTML.SubscriptionV4.PackageComparison.searchContent01',
      subtext: [],
      values: [0, 0, 0, 0]
    },
    {
      content: 'AdminHTML.SubscriptionV4.PackageComparison.searchContent02',
      subtext: [],
      values: [0, 0, 0, 0]
    },
    {
      content: 'AdminHTML.SubscriptionV4.PackageComparison.searchContent03',
      subtext: [],
      values: [-1, 0, 0, 0]
    },
    {
      content: 'AdminHTML.SubscriptionV4.PackageComparison.searchContent04',
      subtext: [],
      values: [-1, 0, 0, 0]
    },
    {
      content: 'AdminHTML.SubscriptionV4.PackageComparison.searchContent05',
      subtext: [],
      values: [0, 0, 0, 0]
    },
    {
      content: 'AdminHTML.SubscriptionV4.PackageComparison.searchContent06',
      subtext: [],
      values: [0, 0, 0, 0]
    },
    {
      content: 'AdminHTML.SubscriptionV4.PackageComparison.searchContent07',
      subtext: [],
      values: [0, 0, 0, 0]
    },
    {
      content: 'AdminHTML.SubscriptionV4.PackageComparison.searchContent08',
      subtext: [],
      values: [0, 0, 0, 0]
    },
    {
      content: 'AdminHTML.SubscriptionV4.PackageComparison.searchContent09',
      subtext: [],
      values: [-1, 20, 40, 100]
    },
    {
      content: 'AdminHTML.SubscriptionV4.PackageComparison.searchContent10',
      subtext: [],
      values: [-1, 0, 0, 0]
    },
    {
      content: 'AdminHTML.SubscriptionV4.PackageComparison.searchContent11',
      subtext: [],
      values: [0, 0, 0, 0]
    },
    // {
    //   content: 'AdminHTML.SubscriptionV4.PackageComparison.searchContent12',
    //   subtext: [],
    //   values: [0, 0, 0]
    // },
    {
      content: 'AdminHTML.SubscriptionV4.PackageComparison.searchContent13',
      subtext: [],
      values: [0, 0, 0, 0]
    },
    {
      content: 'AdminHTML.SubscriptionV4.PackageComparison.searchContent14',
      subtext: [],
      values: [0, 0, 0, 0]
    },
    {
      content: 'AdminHTML.SubscriptionV4.PackageComparison.searchContent15',
      subtext: [],
      values: [0, -1, -1, -1]
    },
    {
      content: 'AdminHTML.SubscriptionV4.PackageComparison.searchContent16',
      subtext: [],
      values: [-1, 0, 0, 0]
    },
    {
      content: 'AdminHTML.SubscriptionV4.PackageComparison.searchContent17',
      subtext: [],
      values: [-1, -1, 0, 0]
    },
    {
      content: 'AdminHTML.SubscriptionV4.PackageComparison.searchContent18',
      subtext: [],
      values: [-1, 'addon', 0, 0],
      isAddon: true
    },
    {
      content: 'AdminHTML.SubscriptionV4.PackageComparison.searchContent19',
      subtext: [],
      values: [-1, 'addon', 0, 0]
    },
    {
      content: 'AdminHTML.SubscriptionV4.PackageComparison.searchContent20',
      subtext: [],
      values: [-1, 'addon', 0, 0]
    },
    {
      content: 'AdminHTML.SubscriptionV4.PackageComparison.searchContent21',
      subtext: [],
      values: [-1, 'addon', 0, 0],
      isAddon: true
    },
    {
      content: 'AdminHTML.SubscriptionV4.PackageComparison.searchContent22',
      subtext: [],
      values: [-1, 'addon', 0, 0],
      isAddon: true
    },
    {
      content: 'AdminHTML.SubscriptionV4.PackageComparison.searchContent23',
      subtext: [],
      values: [-1, -1, 0, 0]
    },
    {
      content: 'AdminHTML.SubscriptionV4.PackageComparison.searchContent24',
      subtext: [],
      values: [-1, -1, -1, 0]
    }
  ],
  advancedProductFilter: [
    {
      content: 'AdminHTML.SubscriptionV4.PackageComparison.apfContent01',
      subtext: [],
      values: [0, 0, 0, 0]
    },
    {
      content: 'AdminHTML.SubscriptionV4.PackageComparison.apfContent02',
      subtext: [],
      values: [0, 0, 0, 0]
    },
    {
      content: 'AdminHTML.SubscriptionV4.PackageComparison.apfContent03',
      subtext: [],
      values: [0, 0, 0, 0]
    },
    {
      content: 'AdminHTML.SubscriptionV4.PackageComparison.apfContent04',
      subtext: [],
      values: [0, 0, 0, 0]
    },
    {
      content: 'AdminHTML.SubscriptionV4.PackageComparison.apfContent05',
      subtext: [],
      values: [-1, 5, 20, 'AdminHTML.SubscriptionV4.PackageComparison.unlimited']
    },
    {
      content: 'AdminHTML.SubscriptionV4.PackageComparison.apfContent06',
      subtext: [],
      values: [-1, 0, 0, 0]
    },
    {
      content: 'AdminHTML.SubscriptionV4.PackageComparison.apfContent07',
      subtext: [],
      values: [-1, 0, 0, 0]
    },
    {
      content: 'AdminHTML.SubscriptionV4.PackageComparison.apfContent08',
      subtext: [],
      values: [-1, 0, 0, 0]
    },
    {
      content: 'AdminHTML.SubscriptionV4.PackageComparison.apfContent09',
      subtext: [],
      values: [-1, 20, 40, 100]
    }
  ],
  visualMerchandising: [
    {
      content: 'AdminHTML.SubscriptionV4.PackageComparison.visualMerchandisingContent01',
      subtext: [],
      values: [-1, 10, 40, 100]
    },
    {
      content: 'AdminHTML.SubscriptionV4.PackageComparison.visualMerchandisingContent02',
      subtext: [],
      values: [-1, 0, 0, 0]
    },
    {
      content: 'AdminHTML.SubscriptionV4.PackageComparison.visualMerchandisingContent03',
      subtext: [],
      values: [-1, 0, 0, 0]
    },
    {
      content: 'AdminHTML.SubscriptionV4.PackageComparison.visualMerchandisingContent04',
      subtext: [],
      values: [-1, 0, 0, 0]
    },
    {
      content: 'AdminHTML.SubscriptionV4.PackageComparison.visualMerchandisingContent05',
      subtext: [],
      values: [-1, -1, 0, 0]
    },
    {
      content: 'AdminHTML.SubscriptionV4.PackageComparison.visualMerchandisingContent06',
      subtext: [],
      values: [-1, 'addon', 'addon', 0]
    }
    // {
    //   content: 'AdminHTML.SubscriptionV4.PackageComparison.visualMerchandisingContent07',
    //   subtext: [],
    //   values: ['addon', 'addon', 0]
    // }
  ],
  recommendation: [
    {
      content: 'AdminHTML.SubscriptionV4.PackageComparison.recommendationContent01',
      subtext: [],
      values: [0, 0, 0, 0]
    },
    {
      content: 'AdminHTML.SubscriptionV4.PackageComparison.recommendationContent02',
      subtext: [],
      values: [-1, 0, 0, 0]
    },
    {
      content: 'AdminHTML.SubscriptionV4.PackageComparison.recommendationContent03',
      subtext: [],
      values: [-1, 0, 0, 0]
    },
    {
      content: 'AdminHTML.SubscriptionV4.PackageComparison.recommendationContent04',
      subtext: [],
      values: [-1, 0, 0, 0]
    },
    {
      content: 'AdminHTML.SubscriptionV4.PackageComparison.recommendationContent05',
      subtext: [],
      values: [-1, 0, 0, 0]
    },
    {
      content: 'AdminHTML.SubscriptionV4.PackageComparison.recommendationContent06',
      subtext: [],
      values: [-1, 0, 0, 0]
    },
    {
      content: 'AdminHTML.SubscriptionV4.PackageComparison.recommendationContent07',
      subtext: [],
      values: [-1, 'addon', 0, 0]
    },
    {
      content: 'AdminHTML.SubscriptionV4.PackageComparison.recommendationContent08',
      subtext: [],
      values: [-1, 'addon', 0, 0],
      isAddon: true
    },
    {
      content: 'AdminHTML.SubscriptionV4.PackageComparison.recommendationContent09',
      subtext: ['AdminHTML.SubscriptionV4.PackageComparison.recommendationContent09_Subtext'],
      values: [-1, 'addon', 0, 0],
      isAddon: true
    },
    {
      content: 'AdminHTML.SubscriptionV4.PackageComparison.recommendationContent10',
      subtext: [],
      values: [-1, 0, 0, 0]
    },
    {
      content: 'AdminHTML.SubscriptionV4.PackageComparison.recommendationContent11',
      subtext: [],
      values: [-1, -1, 0, 0],
      isAddon: true
    },
    {
      content: 'AdminHTML.SubscriptionV4.PackageComparison.postPurchaseContent',
      subtext: [],
      values: [-1, 'addon', 0, 0],
      isAddon: false
    },
    {
      content: 'AdminHTML.SubscriptionV4.PackageComparison.recommendationContent12',
      subtext: [],
      values: [-1, -1, -1, 0],
      isAddon: true
    }
  ],
  personalization: [
    {
      content: 'AdminHTML.SubscriptionV4.PackageComparison.personalizationContent01',
      values: [-1, -1, -1, 0],
      isAddon: true
    },
    {
      content: 'AdminHTML.SubscriptionV4.PackageComparison.personalizationContent02',
      values: [-1, -1, -1, 0],
      isAddon: true
    },
    {
      content: 'AdminHTML.SubscriptionV4.PackageComparison.personalizationContent03',
      isAddon: true,
      values: [-1, -1, -1, 0]
    }
  ],
  analytics: [
    {
      content: 'AdminHTML.SubscriptionV4.PackageComparison.analyticsContent01',
      subtext: [],
      values: [0, 0, 0, 0]
    },
    {
      content: 'AdminHTML.SubscriptionV4.PackageComparison.analyticsContent02',
      subtext: [],
      values: [-1, 0, 0, 0]
    },
    {
      content: 'AdminHTML.SubscriptionV4.PackageComparison.analyticsContent03',
      subtext: [],
      values: [-1, 0, 0, 0]
    },
    {
      content: 'AdminHTML.SubscriptionV4.PackageComparison.analyticsContent04',
      subtext: [],
      values: [-1, -1, 0, 0]
    },
    {
      content: 'AdminHTML.SubscriptionV4.PackageComparison.analyticsContent05',
      subtext: [],
      values: [-1, -1, -1, 0]
    },
    {
      content: 'AdminHTML.SubscriptionV4.PackageComparison.analyticsContent06',
      subtext: [],
      values: [0, 0, 0, 0]
    },
    {
      content: 'AdminHTML.SubscriptionV4.PackageComparison.analyticsContent07',
      subtext: [],
      values: [0, 0, 0, 0]
    },
    {
      content: 'AdminHTML.SubscriptionV4.PackageComparison.analyticsContent08',
      subtext: [],
      values: [0, 0, 0, 0]
    },
    {
      content: 'AdminHTML.SubscriptionV4.PackageComparison.analyticsContent09',
      subtext: [],
      values: [0, 0, 0, 0]
    },
    {
      content: 'AdminHTML.SubscriptionV4.PackageComparison.analyticsContent10',
      subtext: [],
      values: [-1, 0, 0, 0]
    }
  ],
  dynamicProductListing: [
    {
      content: 'AdminHTML.SubscriptionV4.PackageComparison.dynamicProductListingContent01',
      subtext: [],
      values: [-1, 'addon', 'addon', 0]
    }
  ],
  sync: [
    {
      content: 'AdminHTML.SubscriptionV4.PackageComparison.syncContent01',
      subtext: [],
      values: [
        'AdminHTML.SubscriptionV4.PackageComparison.syncContent01_Advanced00',
        'AdminHTML.SubscriptionV4.PackageComparison.syncContent01_Advanced01',
        'AdminHTML.SubscriptionV4.PackageComparison.syncContent01_Advanced02',
        'AdminHTML.SubscriptionV4.PackageComparison.syncContent01_Advanced03'
      ]
    },
    {
      content: 'AdminHTML.SubscriptionV4.PackageComparison.syncContent02',
      subtext: [],
      values: [-1, 0, 0, 0]
    },
    {
      content: 'AdminHTML.SubscriptionV4.PackageComparison.syncContent03',
      subtext: [],
      values: [0, 0, 0, 0]
    },
    {
      content: 'AdminHTML.SubscriptionV4.PackageComparison.syncContent04',
      subtext: [],
      values: [0, 0, 0, 0]
    },
    {
      content: 'AdminHTML.SubscriptionV4.PackageComparison.syncContent05',
      subtext: [],
      values: [0, 0, 0, 0]
    }
  ],
  appVisualization: [
    {
      content: 'AdminHTML.SubscriptionV4.PackageComparison.appVisualizationContent01',
      subtext: [],
      values: [0, 0, 0, 0]
    },
    {
      content: 'AdminHTML.SubscriptionV4.PackageComparison.appVisualizationContent02',
      subtext: [],
      values: [0, 0, 0, 0]
    }
  ],
  support: [
    {
      content: 'AdminHTML.SubscriptionV4.PackageComparison.supportContent01',
      subtext: [],
      values: [-1, 0, 0, 0]
    },
    {
      content: 'AdminHTML.SubscriptionV4.PackageComparison.supportContent02',
      subtext: [],
      values: [-1, -1, -1, 0]
    },
    {
      content: 'AdminHTML.SubscriptionV4.PackageComparison.supportContent03',
      subtext: [],
      values: [-1, -1, -1, 0]
    },
    {
      content: 'AdminHTML.SubscriptionV4.PackageComparison.supportContent04',
      subtext: [],
      values: [-1, -1, -1, 0]
    }
  ],
  globalSales: [
    {
      content: 'AdminHTML.SubscriptionV4.PackageComparison.globalSalesContent01',
      subtext: [],
      values: [-1, 0, 0, 0]
    },
    {
      content: 'AdminHTML.SubscriptionV4.PackageComparison.globalSalesContent02',
      subtext: [],
      values: [-1, 0, 0, 0]
    },
    {
      content: 'AdminHTML.SubscriptionV4.PackageComparison.globalSalesContent03',
      subtext: [],
      values: [-1, 0, 0, 0]
    }
  ],
  b2B: [
    {
      content: 'AdminHTML.SubscriptionV4.PackageComparison.b2B_Sync',
      subtext: [],
      values: [-1, -1, 0, 0]
    },
    {
      content: 'AdminHTML.SubscriptionV4.PackageComparison.b2B_Editor',
      subtext: [],
      values: [-1, -1, 0, 0]
    }
  ],
  preOrder: [
    {
      content: 'AdminHTML.SubscriptionV4.PackageComparison.preOrder',
      subtext: [],
      values: [-1, 0, 0, 0]
    },
    {
      content: 'AdminHTML.SubscriptionV4.PackageComparison.preOrderContent01',
      subtext: [],
      values: [-1, 0, 0, 0]
    },
    {
      content: 'AdminHTML.SubscriptionV4.PackageComparison.preOrderContent02',
      subtext: [],
      values: [
        -1,
        -1,
        'AdminHTML.SubscriptionV4.PackageComparison.preOrderContent02_Value01',
        'AdminHTML.SubscriptionV4.PackageComparison.preOrderContent02_Value02'
      ]
    }
  ]
};

export const SUBSCRIPTION_STATE = {
  LOCKED: 'locked',
  TRIAL: 'trial',
  NOT_TRIAL: 'not-trial',
  UNLOCK: 'unlock',
  EXPIRED: 'expired'
};

export const B2B_LIMIT_RELEASE_DATE = 1724198400;
export const SHOPIFY_MARKET_RELEASE_DATE = 1726635600;

export const FREEMIUM = 'freemium';
export const BASIC = 'basic';
export const ESSENTIAL = 'essential';
export const PROFESSIONAL = 'professional';
export const LAUNCH = 'launch';
export const CONVERT = 'convert';
export const ACCELERATE = 'accelerate';
export const ENTERPRISE = 'enterprise';
